var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.loadMore,
          expression: "loadMore",
        },
      ],
      staticClass: "print-list_box",
      attrs: { id: "nPrintingPageTable" },
    },
    [
      _c(
        "div",
        { staticClass: "yto-box yto-box-pb" },
        [
          _c("searchOptions", {
            ref: "searchOption",
            attrs: {
              curComponent: "waybillDetailPage",
              productList: _vm.productList,
              searchForm: _vm.form,
              fromPage: _vm.curPackageInfo.curComponent,
            },
            on: {
              resetForm: _vm.resetRuleForm,
              searchFormData: _vm.searchFormData,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "yto-table yto-ks-box ksNewOrderTable",
          staticStyle: { position: "relative", padding: "10px 25px" },
        },
        [
          _c(
            "div",
            { staticClass: "y-mb-10 y-w-700 y-fs-12 y-mt-10 y-mb-15" },
            [
              _c("span", [
                _vm._v("包名：" + _vm._s(_vm.curPackageInfo.buildPageName)),
              ]),
              _c("span", { staticClass: "y-ml-20" }, [
                _vm._v(
                  "包签号：" + _vm._s(_vm.curPackageInfo.packageWaybillNo)
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "ksOrderTable ksTableHeightStyle infinite-list-wrapper manyWaybillNoStyle",
              staticStyle: { "margin-bottom": "20px", overflow: "auto" },
            },
            [
              _c(
                "table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass:
                    "el-table el-table--fit el-table--scrollable-x el-table--enable-row-transition el-table--small el-table__header",
                  attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "cell",
                          staticStyle: {
                            "text-align": "center",
                            padding: "0px",
                          },
                          attrs: { width: "32px" },
                        },
                        [
                          _c("svg-icon", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isAllChecked && !_vm.isAllIndemitChecked,
                                expression:
                                  "!isAllChecked && !isAllIndemitChecked",
                              },
                            ],
                            staticClass: "icon-checked",
                            attrs: { "icon-class": "buxuan" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.tableSelectAll.apply(null, arguments)
                              },
                            },
                          }),
                          _c("svg-icon", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isAllChecked,
                                expression: "isAllChecked",
                              },
                            ],
                            staticClass: "icon-checked",
                            attrs: { "icon-class": "quanxuan" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.tableSelectAll.apply(null, arguments)
                              },
                            },
                          }),
                          _c("svg-icon", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isAllIndemitChecked,
                                expression: "isAllIndemitChecked",
                              },
                            ],
                            staticClass: "icon-checked",
                            attrs: { "icon-class": "banxuan" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.tableSelectAll.apply(null, arguments)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("th", { attrs: { width: "180px" } }, [
                        _vm._v("运单号"),
                      ]),
                      _c("th", { attrs: { width: "220px" } }, [
                        _vm._v("订单号"),
                      ]),
                      _c("th", { attrs: { width: "120px" } }, [
                        _vm._v("发件人"),
                      ]),
                      _c("th", { attrs: { width: "280px" } }, [
                        _vm._v("收件人信息"),
                      ]),
                      _c("th", { attrs: { width: "100px" } }, [
                        _vm._v("商品信息"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    [
                      !_vm.tbody.length
                        ? [
                            _c(
                              "tr",
                              {
                                staticClass:
                                  "el-table__body-wrapper is-scrolling-none",
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "el-table__expanded-cell",
                                    staticStyle: { "text-align": "center" },
                                    attrs: { colspan: 6 },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-table__empty-text" },
                                      [_vm._v("暂无数据")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._l(_vm.tbodyBak, function (item, index) {
                        return [
                          _c(
                            "tr",
                            {
                              key: index,
                              staticClass: "el-table__row",
                              class: {
                                "table-active-row": _vm.tableRowClassName(item),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.checkedRow(item)
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("svg-icon", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !item.isChecked &&
                                          !item.isPartChecked,
                                        expression:
                                          "!item.isChecked && !item.isPartChecked",
                                      },
                                    ],
                                    staticClass: "icon-checked",
                                    attrs: { "icon-class": "buxuan" },
                                  }),
                                  _c("svg-icon", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !item.isPartChecked && item.isChecked,
                                        expression:
                                          "!item.isPartChecked && item.isChecked",
                                      },
                                    ],
                                    staticClass: "icon-checked",
                                    attrs: { "icon-class": "quanxuan" },
                                  }),
                                  _c("svg-icon", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.isPartChecked,
                                        expression: "item.isPartChecked",
                                      },
                                    ],
                                    staticClass: "icon-checked",
                                    attrs: { "icon-class": "banxuan" },
                                  }),
                                ],
                                1
                              ),
                              _c("td", { staticClass: "opacity-coloumn" }, [
                                _c("div", [
                                  _c("span", [
                                    _vm._v(_vm._s(item.mailNo || "")),
                                  ]),
                                ]),
                              ]),
                              _c("td", { staticClass: "opacity-coloumn" }, [
                                _c("div", [_vm._v(_vm._s(item.orderNo || ""))]),
                              ]),
                              _c("td", { staticClass: "opacity-coloumn" }, [
                                _c("div", [_vm._v(_vm._s(item.senderName))]),
                              ]),
                              _c("td", { staticClass: "opacity-coloumn" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cell",
                                    staticStyle: { "padding-right": "10px" },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top-start",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(item.receiverName || "") +
                                              " " +
                                              _vm._s(item.receiverMobile || "")
                                          ),
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(item.receiveProv || "") +
                                              _vm._s(item.receiveCity || "") +
                                              _vm._s(item.receiveDict || "") +
                                              _vm._s(item.receiveAddress || "")
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "elli2",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  item.receiverName || ""
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    item.receiverMobile || ""
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(item.receiveProv || "") +
                                                  _vm._s(
                                                    item.receiveCity || ""
                                                  ) +
                                                  _vm._s(
                                                    item.receiveDict || ""
                                                  ) +
                                                  _vm._s(
                                                    item.receiveAddress || ""
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("td", { staticClass: "opacity-coloumn" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cell",
                                    staticStyle: { "padding-right": "10px" },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "top-start",
                                          trigger: "hover",
                                          width: "230",
                                        },
                                      },
                                      [
                                        _vm._l(
                                          item.goodInfoResponseList,
                                          function (pro, pri) {
                                            return _c("div", { key: pri }, [
                                              _vm._v(
                                                _vm._s(
                                                  `${pro.productName || ""} * ${
                                                    pro.productNum || 1
                                                  } / 重量：`
                                                )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "y-fc-F0484A":
                                                      !pro.productWeight,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      pro.productWeight
                                                        ? parseInt(
                                                            pro.productWeight *
                                                              100
                                                          ) / 100
                                                        : 0
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v("Kg"),
                                            ])
                                          }
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "elli2",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          _vm._l(
                                            item.goodInfoResponseList,
                                            function (pro, pri) {
                                              return _c("div", { key: pri }, [
                                                _vm._v(
                                                  _vm._s(
                                                    `${
                                                      pro.productName || ""
                                                    } * ${
                                                      pro.productNum || 1
                                                    } / 重量：`
                                                  )
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    class: {
                                                      "y-fc-F0484A":
                                                        !pro.productWeight,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        pro.productWeight
                                                          ? parseInt(
                                                              pro.productWeight *
                                                                100
                                                            ) / 100
                                                          : 0
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Kg"),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "paginton-footer-box box-shadow-wrapper" },
            [
              _vm.isRefreshTemplate
                ? _c("changeTemplate", {
                    attrs: {
                      platformCode: "BQDYXQ",
                      curComponent: "PACKUP_PACKAGE",
                      templateAList: _vm.templateAList,
                      curTemplateId: _vm.repeatPrintedForm.tempId,
                    },
                    on: {
                      changeTemplateId: _vm.changeTemplateId,
                      addOneTemplate: function ($event) {
                        _vm.isShowAddTemplateDialog = true
                      },
                      deleteTemplate: _vm.deleteTemplate,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "split-line" }),
              _c(
                "div",
                { staticClass: "totalFooter-top y-f-a" },
                [
                  _c("div", { staticClass: "print-footer-left y-f y-f-a" }, [
                    _c("span", [
                      _vm._v("已选"),
                      _c("span", { staticClass: "totalNumStyle systemColor" }, [
                        _vm._v(_vm._s(_vm.selectData.length)),
                      ]),
                      _vm._v("条记录"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "print-footer-medium y-f y-f-a" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "border-btn",
                          on: { click: _vm.batchPrinting },
                        },
                        [_vm._v("打印运单")]
                      ),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-sizes": [50, 100, 200, 300, 400],
                      "page-size": _vm.limit,
                      "pager-count": 5,
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.limitChange,
                      "current-change": _vm.pageChange,
                      "update:currentPage": function ($event) {
                        _vm.pageNo = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.pageNo = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "打印运单",
            visible: _vm.repeatPrintedDialogVisible,
            width: "725px",
            "custom-class": "ninvoiceDialog",
            "close-on-click-modal": false,
            "before-close": _vm.closeRepeatForm,
          },
          on: {
            "update:visible": function ($event) {
              _vm.repeatPrintedDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "repeatPrintedForm",
              attrs: {
                model: _vm.repeatPrintedForm,
                "label-width": "190px",
                rules: _vm.repeatPrintedFormRules,
              },
            },
            [
              _c("printWarningTip", {
                attrs: {
                  dygfWaybillList: _vm.dygfWaybillList || {},
                  selectPrinterForm: _vm.repeatPrintedForm,
                },
              }),
              _c(
                "el-form-item",
                { attrs: { label: "您本次选择的打印模板是：" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content: `${_vm.curTemplateInfo.addressInfo || ""}`,
                        placement: "top-start",
                      },
                    },
                    [
                      _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.curTemplateInfo.tempName)),
                        ]),
                        !_vm.cpCodeList.includes(_vm.curTemplateInfo.wpCode)
                          ? _c(
                              "span",
                              {
                                class: {
                                  systemGreenColor:
                                    _vm.repeatPrintedForm.available >= 100,
                                  systemRedColor:
                                    _vm.repeatPrintedForm.available < 100,
                                },
                              },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.repeatPrintedForm.available || 0
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "快递单打印机", prop: "printer" } },
                [
                  _c(
                    "span",
                    { staticClass: "custom-select-style" },
                    [
                      _c("span", {
                        staticClass: "systemColor",
                        domProps: {
                          textContent: _vm._s(_vm.getDefautPrinter()),
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-select-border-style",
                          class: {
                            "custom-select-style-input-default-printer":
                              _vm.getDefautPrinter() == "默认",
                            "custom-select-style-input-pinter":
                              _vm.getDefautPrinter() !== "默认",
                          },
                          attrs: {
                            "popper-append-to-body": false,
                            placeholder: "请选择快递单打印机",
                          },
                          model: {
                            value: _vm.repeatPrintedForm.printer,
                            callback: function ($$v) {
                              _vm.$set(_vm.repeatPrintedForm, "printer", $$v)
                            },
                            expression: "repeatPrintedForm.printer",
                          },
                        },
                        _vm._l(_vm.dyPrinterList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.dyPrinterList.length
                    ? _c(
                        "span",
                        {
                          staticClass: "systemColor",
                          staticStyle: {
                            "font-size": "12px",
                            "margin-left": "5px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.setDefaultPrinter },
                        },
                        [_vm._v("设置默认打印机")]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer align-center-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeRepeatForm } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.repeatSubmitPrint },
                },
                [_vm._v("打印运单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isShowValidateDialog
        ? _c("validatePrintItems", {
            attrs: {
              isShow: _vm.isShowValidateDialog,
              senderList: [],
              curSenderId: _vm.repeatPrintedForm.sernderId,
              templateAList: _vm.templateAList,
              curTemplateId: _vm.repeatPrintedForm.tempId,
              step: _vm.validateStep,
              platformType: "BQDY",
            },
            on: {
              closeValiDialog: _vm.closeValiDialog,
              refreshOriginList: _vm.refreshOriginList,
              addOneTemplate: _vm.addOneTemplate,
            },
          })
        : _vm._e(),
      _vm.isShowAddTemplateDialog
        ? _c("addTemplateDialog", {
            attrs: {
              visible: _vm.isShowAddTemplateDialog,
              tplList: _vm.templateAList,
              defaultCpCode: _vm.defaultCpCode,
              defaultPlatformType: _vm.defaultPlatformType,
              closeByConfirm: _vm.getTemplateList,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isShowAddTemplateDialog = $event
              },
            },
          })
        : _vm._e(),
      _c("orderPrint", {
        ref: "orderPrintComponent",
        on: { "close-print-dialog": _vm.closePrinterDialog },
      }),
      _c("order-detail", {
        attrs: {
          info: JSON.stringify(_vm.detailInfo),
          value: _vm.orderDetialDialogVisible,
        },
        on: { close: _vm.closeDetialDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }